import React, { ReactElement } from 'react'
import { Text } from '@mindfulchefuk/design-system'

type TRecipeInstructionTitle = {
  title: string
}

export const RecipeInstructionTitle = ({
  title,
}: TRecipeInstructionTitle): ReactElement => {
  return (
    <Text
      variant="body-lg-500"
      as="li"
      listStyleType="none"
      data-testid="instruction-title"
    >
      {title}
    </Text>
  )
}
